import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"success\"><path d=\"M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.067a6.933 6.933 0 100 13.866A6.933 6.933 0 008 1.067z\" /><path d=\"M13.763 6.05L7.503 12 4.081 8.716a.567.567 0 01.113-.718.643.643 0 01.761-.066l2.548 2.422 5.377-5.11a.634.634 0 01.622-.233.605.605 0 01.481.44.572.572 0 01-.22.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol